<template lang="pug">
	.plan-card(:class="{'comparing': isAPlanToCompare(plan) }")
		.plan-logo
			div(v-if="hidePlanLink")
				b-img-lazy.img.logo(:src="plan.logo_url" :alt="plan.name +  ' logo'")
			a(v-else :href="plan.plan_details_url" @click="trackPlanDetailsClick('image_link')")
				b-img-lazy.img.logo(:src="plan.logo_url" :alt="plan.name +  ' logo'")
			img.top-ten(v-if="plan.rating_designation != '--'" :src="`https://s3.us-west-2.amazonaws.com/webresources.savingforcollege.com/images/honors/${plan.rating_designation}.svg`" :alt="$t('top_10')")
		.plan-details
			.description-section
				.plan-name
					div(v-if="hidePlanLink")
						h3
							| {{plan.name}}
					a(v-else :href="plan.plan_details_url" @click="trackPlanDetailsClick('title_link')")
						h3
							| {{plan.name}}
				p.disclaimer(v-if="stateResidencyRequirement(plan)")
						| {{ $t("restricted_to", {state: plan.state_object.name }) }}
				.description
					p(v-html="plan.description")

			.ratings-section
				.rating(:class="{'special-score': plan.is_prepaid || plan.is_fdic}") 
					.rating-label(v-if="!(plan.is_prepaid || plan.is_fdic)")
						p Our Rating
					.caps(:class="{'caps-special': plan.is_prepaid || plan.is_fdic}")
						sfc-cap-rating(:score="plan.overall_rating" :format="1" :prepaid="plan.is_prepaid" :fdic="plan.is_fdic" :showCount="showCount" :maxScore="(plan.is_prepaid || plan.is_fdic) ? 1:5")
				.rating(v-if="!(plan.is_prepaid || plan.is_fdic) && plan.resident_benefits != '0'") 
					.rating-label
						p Resident Benefits
					.caps
						sfc-resident-benefits(:residentBenefits="plan.resident_benefits")
		.gray-section
			.enroll-now-container
				sfc-simple-button(v-if="nonUs && plan.name=='NextGen 529 -- Client Direct Series'"
					text="ENROLL NOW"
					:blue="true"
					:link="true"
					:medium-size="true"
					:href="`${$store.state.config.sfcHost}/non-us-user-merrill`")
				sfc-enroll-now-button(v-else-if="customEnrollNowUrl"
					:plan="plan"
					:page="page"
					target="_blank"
					:show-enroll-now-count="true"
					:click-source="clickSource"
					:plan-details-show-link="false"
					@enrollNowCallback="trackEnrollNowClickCallback"
					context-placement="card")
				sfc-enroll-now-button(v-else
					:plan="plan"
					:page="page"
					target="_blank"
					:show-enroll-now-count="true"
					:click-source="clickSource"
					:plan-details-show-link="true"
					context-placement="card")
				
			.check-compare(v-if="showCompareCheckbox")
				div.checkbox-text(v-if="!isAPlanToCompare(plan)") {{ $t("compare" )}}
				div.checkbox-text.comparing(v-else) {{ $t("comparing") }}
				label.checkbox-container
					sfc-compare-checkbox(:plan="plan")
</template>

<style lang="stylus" scoped>
@import '~assets/css/redesign-v1/variables.styl'

.plan-card
		display: flex
		flex-wrap: wrap
		border-radius(4px)
		box-shadow()
		background: #fff
		margin-bottom: 40px
		@media (max-width: 575px)
			margin-bottom: 16px
		&:last-of-type
			margin-bottom: 0
		@media (max-width: 767px)
			display: block
		.plan-logo
			margin: 0 auto
			display: block
			padding: 24px 8px 9px 24px
			text-align: center
			@media (max-width: 767px)
				padding: 16px
			@media (min-width: 768px) and (max-width: 991px)
				padding-left: 16px
			.logo
				width: 160px
				height: 96px
				margin: 0 auto
				border-radius(2px)
				border: 1px solid plan-logo-img-border
			.top-ten
				width: 87px
				height: 90px
				margin-top: 10px
				@media (max-width: 767px)
					margin-top: 0
					margin-left: 20px
				@media (min-width: 768px)
					display: block
					margin: 20px auto 0

		.plan-details
			flex-grow: 1
			flex-shrink: 0
			flex-basis: 0px
			padding: 24px 24px 24px 16px
			text-align: left
			@media (max-width: 767px)
				padding: 0 16px 16px
				text-align: center
				unset-flex()
			@media (min-width: 768px) and (max-width: 991px)
				padding: 24px 16px 24px 8px
			.description-section
				border-bottom: 1px solid plan-card-divider-line
				padding-bottom: 16px
				.plan-name
					margin-bottom: 4px
					line-height: normal
					a
						display: block
						margin: 0 auto
						text-decoration: underline
						color: body-font-color-black !important
						&:hover
							color: blue-primary !important
						h3
							margin-bottom: 0
							&:hover
								color: blue-primary !important
				p.disclaimer
					font-size: body-font-size-xs
					color: gray-50
					line-height: normal
				.description
					font-size: body-font-size-md
					color: body-font-color-black
					margin-bottom: 0
					clamp-text(24px, 2)

			.ratings-section
				padding-top: 16px
				display: flex
				flex-wrap: wrap
				flex-direction: row
				.rating
					margin-right: 32px
					&:last-of-type
						margin-right: 0
					@media (max-width: 1010px)
						width: 100%
						margin: 0 0 8px
						display: flex
						text-align: left
						line-height: body-font-line-heigth-xs
						&:last-of-type
							margin-bottom: 0
					.rating-label
						@media (max-width: 369px)
							width: 60%
						@media (min-width: 370px) and (max-width: 1010px)
							width: 40%
							overflow: hidden
							text-overflow: ellipsis
						@media (min-width: 1011px) and (max-width: 1050px)
							max-width: 150px
							display: inline-block
						p
							color: body-font-color-black
							display: inline-block
							margin-bottom: 0
						.tooltip-icon
							margin-left: 4px
							display: inline-block
							@media (max-width: 1010px)
								display: none
					.caps
						@media (max-width: 1010px)
							width: 60%
						.score
							font-size: body-font-size
						&.caps-special
							margin-bottom: 20px
							@media (max-width: 768px)
								width: 100%!important
		.gray-section
			background: gray-4
			padding: 57px 0
			flex-grow: 0
			flex-shrink: 0
			flex-basis: 24.5%
			text-align: center
			border-top-right-radius: 4px
			border-bottom-right-radius: 4px
			@media (max-width: 767px)
				unset-flex()
			@media (min-width: 768px) and (max-width: 1010px)
				display: flex
				flex-direction: column
				justify-content: space-between
				align-items: center
			@media (max-width: 1010px)
				padding: 24px 16px 16px
			.enroll-now-container
				max-width: 200px
				margin: 0 auto
				text-align: center
				@media (min-width: 768px) and (max-width: 1010px)
					max-width: 150px
			.check-compare
				margin-top: 32px
				white-space: nowrap !important
				@media (max-width: 767px)
					margin-top: 8px
				.checkbox-text
					display: inline-block
					margin-right: 15px
					font-size: body-font-size-xs + 1
					font-weight: body-font-weight-medium
					text-transform: uppercase
					color: body-font-color-black
					@media (max-width: 767px)
						margin-right: 12px
				.checkbox-container
					margin: 0
					vertical-align: middle
</style>
<script>
import Vue from 'vue'
import { directive as onClickOutside } from 'vue-on-click-outside'
import SfcUtil from '@/lib/sfc-util.js'
import SfcCapRating from '@/common/components/redesign-v1/sfc-cap-rating'
import SfcResidentBenefits from "@/common/components/redesign-v1/sfc-resident-benefits"
import SfcStarRating from '@/common/components/redesign-v1/sfc-star-rating'
import SfcTooltipIcon from '@/common/components/icons/redesign-v1/sfc-tooltip-icon'
import SfcEnrollNowButton from '@/common/components/redesign-v1/sfc-enroll-now-button'
import SfcCompareCheckbox from '@/common/components/plan/redesign-v1/sfc-compare-checkbox'
import SfcSimpleButton from '@/common/components/redesign-v1/sfc-simple-button'
import SfcTrackingService from '@/lib/sfc-tracking-service'

Vue.directive('on-click-outside', onClickOutside)

export default {
	props: [
		'plan',
		'clickSource',
		'years',
		'userState',
		'page',
		'showCompareCheckbox',
		'nonUs',
		'customEnrollNowUrl',
		'showCount',
		'hidePlanLink'
	],

	components: {
		SfcCapRating,
		SfcResidentBenefits,
		SfcStarRating,
		SfcTooltipIcon,
		SfcCompareCheckbox,
		SfcEnrollNowButton,
		SfcSimpleButton
	},

	data() {
		let tooltipFeeRank = this.$t('fee_score_tooltip')
		return {
			ready: true,
			internalShowTooltip: true,
			tooltipFeeRank
		}
	},

	computed: {
		tooltipPerfRank() {
			let year = 'five'
			switch (this.years) {
				case 1:
					year = 'one'
					break
				case 3:
					year = 'three'
					break
				case 5:
					year = 'five'
					break
				case 10:
					year = 'ten'
					break
				default:
					year = 'five'
					break
			}
			return this.$t('performance_tooltip')
		}
	},

	methods: {
		trackPlanDetailsClick(designVersion) {
			SfcTrackingService.trackPlanDetailsClick({
				page: this.page,
				plan: this.plan,
				contextPlacement: 'card',
				clickSource: this._props.clickSource,
				designVersion
			})
		},
		stateResidencyRequirement(plan) {
			if (
				['No', 'None', '--', null, undefined].indexOf(plan.state_residency_requirements) != -1 ||
				plan.state_residency_requirements == ''
			) {
				return false
			}
			return true
		},
		isAPlanToCompare(plan) {
			return SfcUtil.isAPlanToCompare(this.$store.state.plansToCompare, plan)
		},
		closePopover() {
			this.internalShowTooltip = false
		},
		performanceScore(plan) {
			let score = 'N/A'
			if (plan.one_year_performance_five_star_score && this.years == 1) {
				score = plan.one_year_performance_five_star_score
			}
			if (plan.three_year_performance_five_star_score && this.years == 3) {
				score = plan.three_year_performance_five_star_score
			}
			if (plan.five_year_performance_five_star_score && this.years == 5) {
				score = plan.five_year_performance_five_star_score
			}
			if (plan.ten_year_performance_five_star_score && this.years == 10) {
				score = plan.ten_year_performance_five_star_score
			}
			if (
				(this.years == null || this.years == undefined || this.years == '') &&
				plan.performance_five_star_score != null
			) {
				score = plan.performance_five_star_score
			}
			return score
		},
		capText(value) {
			if (value.length < 165) {
				return value
			}
			let paragraph = ''
			let i = 0
			const words = value.split(' ')
			while (paragraph.length < 165 && paragraph.length + words[i].length < 165) {
				paragraph += ` ${words[i]}`
				i++
			}
			return paragraph.trim() + '...'
		},

		trackEnrollNowClickCallback() {
			this.$emit('track-enroll-now-click')
		}
	}
}
</script>
